var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91797 15.8204V17.0827H4.18024C5.20211 17.0827 5.71305 17.0827 6.17248 16.8924C6.63191 16.7021 6.99319 16.3408 7.71577 15.6182L15.9357 7.39825C16.6712 6.66278 17.0389 6.29504 17.0796 5.84373C17.0863 5.76912 17.0863 5.69405 17.0796 5.61944C17.0389 5.16813 16.6712 4.80038 15.9357 4.06492C15.2002 3.32945 14.8325 2.96171 14.3812 2.92106C14.3066 2.91433 14.2316 2.91433 14.1569 2.92106C13.7056 2.96171 13.3379 3.32945 12.6024 4.06492L4.38244 12.2849C3.65986 13.0074 3.29858 13.3688 3.10827 13.8282C2.91797 14.2876 2.91797 14.7985 2.91797 15.8204Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08984 17.7285H14.6982",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.41602L14.5833 8.74935",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.3cc35247ea5596791cd48882a44796b0.svg";
export { ForwardRef as ReactComponent };